var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indexbg"
  }, [_c('topbar'), _vm._v(" "), _c('header'), _vm._v(" "), _c('emallheader'), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-shopping-cart"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bd-box fill-address"
  }, [_vm._m(1), _vm._v(" "), _c('dt', {
    staticClass: "dt-jsz"
  }, [_vm._v("寄送至")]), _vm._v(" "), _vm._l((_vm.addressBoList), function(addressBo, index) {
    return _c('div', [_c('dl', {
      staticClass: "active dl-active",
      staticStyle: {
        "color": "#666"
      },
      attrs: {
        "name": "addressNode",
        "id": 'dl_' + addressBo.id
      }
    }, [_c('dd', [_c('a', {
      staticClass: "co-b-2 edit-addr fr",
      on: {
        "click": function($event) {
          _vm.editAddress(addressBo.id)
        }
      }
    }, [_vm._v("修改本地址")]), _vm._v(" "), _c('input', {
      attrs: {
        "name": "addressChk",
        "type": "radio"
      },
      domProps: {
        "value": addressBo.id,
        "checked": addressBo.id == _vm.addressId
      },
      on: {
        "click": function($event) {
          _vm.chooseAddress(addressBo.id, index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "addr"
    }, [_vm._v(_vm._s(addressBo.province) + " " + _vm._s(addressBo.city) + " " + _vm._s(addressBo.district) + " " + _vm._s(addressBo.address) + "（" + _vm._s(addressBo.contextName) + " 收）")]), _vm._v(" "), _c('span', {
      staticClass: "tel"
    }, [_vm._v(_vm._s(addressBo.mobile))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "id": "addressId"
      },
      domProps: {
        "value": addressBo.contextName
      }
    })])])])
  }), _vm._v(" "), (_vm.canCreateAddress) ? _c('div', {
    staticClass: "ft-add-addr"
  }, [_c('a', {
    staticClass: "co-b-2 add-addr",
    on: {
      "click": function($event) {
        _vm.addAddress()
      }
    }
  }, [_c('i', [_vm._v("+")]), _vm._v("使用新地址")])]) : _vm._e()], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bd-box fill-ordering mt20"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_vm._l((_vm.shopBoList), function(shop, index) {
    return _c('div', {
      staticClass: "items"
    }, [_vm._l((shop.boListIn), function(bo) {
      return _c('dl', [_c('dd', {
        staticClass: "col-1"
      }, [_c('img', {
        staticClass: "fl",
        attrs: {
          "src": bo.imgSmall,
          "width": "75",
          "height": "75"
        }
      }), _vm._v(" "), _c('a', {
        staticClass: "co-b-2 name",
        on: {
          "click": function($event) {
            _vm.toDetail(bo.goodsCode)
          }
        }
      }, [_vm._v(_vm._s(bo.goodsName))]), _vm._v(" "), (bo.seven_day_return == 'Y' || bo.sevenDayReturn == 'Y') ? _c('span', {
        staticClass: "co-b-2 name",
        staticStyle: {
          "padding-top": "10px"
        }
      }, [_c('i', {
        staticClass: "ico-sp-tk"
      }), _vm._v("支持7天无理由退货服务")]) : _vm._e()]), _vm._v(" "), _c('dd', {
        staticClass: "col-2 sp-meta"
      }, _vm._l((bo.deliveryTypeArray), function(typeItem) {
        return (typeItem != null && typeItem != '') ? _c('span', {
          staticClass: "td-txt",
          class: {
            selected: typeItem.typeCode == bo.deliveryType
          },
          on: {
            "click": function($event) {
              _vm.chooseDeliveryType(typeItem.typeCode, bo)
            }
          }
        }, [_vm._v(_vm._s(typeItem.typeName))]) : _vm._e()
      })), _vm._v(" "), (bo.unitPrice > 0 && bo.goodsPrice == 0) ? _c('dd', {
        staticClass: "col-3 co4"
      }, [_vm._v("￥" + _vm._s(bo.unitPrice))]) : (bo.unitPrice == 0 && bo.goodsPrice > 0) ? _c('dd', {
        staticClass: "col-3 co4"
      }, [_vm._v(_vm._s(bo.goodsPrice) + "\n\t\t\t\t\t\t\t\t"), (bo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (bo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (bo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (bo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()]) : (bo.unitPrice > 0 && bo.goodsPrice > 0) ? _c('dd', {
        staticClass: "col-3 co4"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t￥" + _vm._s(bo.unitPrice) + " + " + _vm._s(bo.goodsPrice) + "\n\t\t\t\t\t\t\t\t"), (bo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (bo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (bo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (bo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('dd', {
        staticClass: "col-4 co4"
      }, [_vm._v("￥" + _vm._s((_vm.printServicePara + _vm.rebrandingServicePara + _vm.printingServicePara + _vm.laserServicePara) / 100))]), _vm._v(" "), _c('dd', {
        staticClass: "col-5 co4",
        attrs: {
          "name": "number"
        }
      }, [_vm._v(_vm._s(bo.goodsNumber))]), _vm._v(" "), _c('dd', {
        staticClass: "col-6 co-r-1 f14"
      }, [(bo.unitPrice > 0) ? _c('span', {
        attrs: {
          "name": "unitPrice"
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t￥" + _vm._s(((bo.unitPrice + (_vm.printServicePara + _vm.rebrandingServicePara + _vm.printingServicePara + _vm.laserServicePara) / 100) * bo.goodsNumber).toFixed(2)) + "\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (bo.unitPrice > 0 && bo.goodsPrice > 0) ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t+\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (bo.goodsPrice > 0) ? _c('span', {
        attrs: {
          "name": "goodsPrice"
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s((bo.goodsPrice * bo.goodsNumber)) + "\n\t\t\t\t\t\t\t\t\t"), (bo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (bo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (bo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (bo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()]) : _vm._e()])])
    }), _vm._v(" "), (shop.expressFee > 0 && _vm.goodsBo.deliveryType != 'self_take') ? _c('div', {
      staticClass: "hd",
      staticStyle: {
        "background": "#f9f8fa",
        "height": "30px",
        "line-height": "30px"
      }
    }, [_c('dl', [_vm._m(5, true), _vm._v(" "), _c('dt', {
      staticClass: "col-3",
      staticStyle: {
        "visibility": "hidden"
      }
    }, [_vm._v("单价")]), _vm._v(" "), _c('dt', {
      staticClass: "col-4",
      staticStyle: {
        "visibility": "hidden"
      }
    }, [_vm._v("数量")]), _vm._v(" "), _c('dt', {
      staticClass: "col-2",
      staticStyle: {
        "visibility": "hidden"
      }
    }, [_vm._v("服务费")]), _vm._v(" "), _c('dt', {
      staticClass: "col-5",
      staticStyle: {
        "color": "#e3101e"
      }
    }, [_vm._v("运费：￥" + _vm._s((shop.expressFee / 100).toFixed(2)))])])]) : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "total tr co5"
  }, [_vm._v("\n\t\t\t\t\t\t已选"), _c('span', {
    staticClass: "m10"
  }, [_vm._v(_vm._s(_vm.sumCount))]), _vm._v("件商品 合计：\n\t\t\t\t\t\t"), (_vm.goodsTotalPrice.totalPoint > 0) ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalPoint) + "积分"), (_vm.sumOrderAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalRed > 0) ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalRed) + "红积分+")]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalBlue > 0) ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalBlue) + "蓝积分+")]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalSpecial > 0) ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalSpecial) + "专用积分+")]) : _vm._e(), _vm._v(" "), (_vm.usableCouponList != '') ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [(_vm.sumOrderAmount > 0) ? _c('span', [_vm._v("￥" + _vm._s((_vm.sumOrderAmount).toFixed(2)))]) : _vm._e(), (_vm.totalExpressAmount > 0 && _vm.goodsBo.deliveryType != 'self_take') ? _c('span', [_vm._v("+￥" + _vm._s((_vm.totalExpressAmount / 100).toFixed(2)))]) : _vm._e(), (_vm.couponDiscountAmount > 0) ? _c('span', [_vm._v("-￥" + _vm._s((_vm.couponDiscountAmount / 100).toFixed(2)))]) : _vm._e()]) : _c('span', {
    staticClass: "co-o-1 f18"
  }, [(_vm.sumOrderAmount > 0) ? _c('span', [_vm._v("￥" + _vm._s((_vm.sumOrderAmount).toFixed(2)))]) : _vm._e(), (_vm.totalExpressAmount > 0 && _vm.goodsBo.deliveryType != 'self_take') ? _c('span', [_vm._v("+￥" + _vm._s((_vm.totalExpressAmount / 100).toFixed(2)))]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brokerDiscountAmount > 0 && _vm.discountType == 'broker_level') ? _c('span', [_vm._v("会员折扣：")]) : _vm._e(), (_vm.brokerDiscountAmount > 0 && _vm.discountType == 'broker_level') ? _c('span', {
    staticClass: "co-o-1 f18"
  }, [_vm._v("-￥" + _vm._s((_vm.brokerDiscountAmount / 100).toFixed(2)))]) : _vm._e(), _vm._v(" "), (_vm.orderSource == 'cart') ? _c('p', {
    staticClass: "mt15"
  }, [_c('router-link', {
    staticClass: "co-b-1 f14",
    attrs: {
      "to": {
        path: '/shopCart'
      },
      "href": "#"
    }
  }, [_vm._v("返回购物车 >")])], 1) : _vm._e()]), _vm._v(" "), _vm._l((_vm.points), function(pointBo, index) {
    return (pointBo.discountMoney > 0 && _vm.seckillPrice == '') ? _c('div', {
      staticClass: "total tr co5"
    }, [_c('span', {
      staticStyle: {
        "line-height": "1.5rem"
      }
    }, [_vm._v("使用\n\t\t\t\t\t\t\t\t" + _vm._s(pointBo.usableNum) + "积分抵用\n\t\t\t\t\t\t\t\t" + _vm._s(pointBo.discountMoney) + "元")]), _vm._v(" "), _c('div', {
      staticClass: "mui-left mui-ellipsis",
      staticStyle: {
        "float": "right"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pointBo.is_choosed),
        expression: "pointBo.is_choosed"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(pointBo.is_choosed) ? _vm._i(pointBo.is_choosed, null) > -1 : (pointBo.is_choosed)
      },
      on: {
        "click": function($event) {
          _vm.chkDiscount()
        },
        "__c": function($event) {
          var $$a = pointBo.is_choosed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (pointBo.is_choosed = $$a.concat([$$v]))
            } else {
              $$i > -1 && (pointBo.is_choosed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            pointBo.is_choosed = $$c
          }
        }
      }
    })])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "fill-ordering-ft"
  }, [_vm._v("\n\t\t\t\t订单消费总计：\n\t\t\t\t"), (_vm.discountType == 'point' && (_vm.pointNum + _vm.goodsTotalPrice.totalPoint) > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.pointNum + _vm.goodsTotalPrice.totalPoint) + "积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : (_vm.discountType != 'point' && _vm.goodsTotalPrice.totalPoint > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalPoint) + "积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalRed > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalRed) + "红积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalBlue > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalBlue) + "蓝积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsTotalPrice.totalSpecial > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v(_vm._s(_vm.goodsTotalPrice.totalSpecial) + "专用积分"), (_vm.sumAmount > 0) ? _c('span', [_vm._v("+")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsBo.deliveryType == 'self_take' && (_vm.sumOrderAmount - _vm.discountAmount) > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v("¥" + _vm._s((_vm.sumOrderAmount - _vm.discountAmount).toFixed(2)))]) : (_vm.goodsBo.deliveryType != 'self_take' && (_vm.sumOrderAmount - _vm.discountAmount + _vm.totalExpressAmount / 100) > 0) ? _c('span', {
    staticClass: "f20 co2"
  }, [_vm._v("¥" + _vm._s((_vm.sumOrderAmount - _vm.discountAmount + _vm.totalExpressAmount / 100).toFixed(2)))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "a-btn-submit ml20",
    on: {
      "click": function($event) {
        _vm.submitOrderExt()
      }
    }
  }, [_vm._v("提交订单")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "ui-mask",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui-dialog",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mainId"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "ui-dialog-content"
  }, [_c('div', {
    staticClass: "invoice-dialog",
    attrs: {
      "id": "invoice-tab"
    }
  }, [_c('div', {
    staticClass: "tab-nav"
  }, [_c('ul', [_c('li', {
    staticClass: "tab-nav-item tab-item-selected",
    attrs: {
      "id": "click_2"
    },
    on: {
      "click": function($event) {
        _vm.change2()
      }
    }
  }, [_vm._v("企业发票"), _c('b')]), _vm._v(" "), _c('li', {
    staticClass: "tab-nav-item",
    attrs: {
      "id": "click_3"
    },
    on: {
      "click": function($event) {
        _vm.change3()
      }
    }
  }, [_vm._v("增值税专用发票"), _c('b')])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-con ui-switchable-panel-selected",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "ele-inv"
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_vm._m(8), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "invoice_ceshi1",
      "name": "invoice_ceshi1",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发票抬头")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "invoice-list invoice-tit-list",
    attrs: {
      "id": "invoice-tit-list_lest"
    }
  }, [_c('div', {
    staticClass: "invoice-item rise invoice-item-selected",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectTitle($event, '-1', '')
      }
    }
  }, [_vm._m(9)]), _vm._v(" "), _vm._l((_vm.enterpriseList), function(enterprise) {
    return _c('div', {
      staticClass: "invoice-item rise",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectTitle($event, enterprise.id, enterprise.taxpayerNum)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "invoice-2"
      }
    }, [_c('input', {
      staticClass: "itxt",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "text",
        "id": "fff",
        "readonly": "true"
      },
      domProps: {
        "value": enterprise.receiptTitle
      }
    }), _c('b')])])
  }), _vm._v(" "), _c('div', {
    staticClass: "invoice-item rise",
    staticStyle: {
      "cursor": "pointer",
      "display": "none"
    },
    attrs: {
      "id": "newReceiptTitle"
    },
    on: {
      "click": function($event) {
        _vm.selectTitle($event, '0', '')
      }
    }
  }, [_vm._m(10)])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "item nor-inv-type0",
    attrs: {
      "id": "addEnterpriseRecipes"
    },
    on: {
      "click": function($event) {
        _vm.addEnterprise()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "item invoice_content"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("发票内容")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "invoice-list"
  }, [_c('ul', {
    attrs: {
      "id": "electro_book_content_radio"
    }
  }, [_c('li', {
    staticClass: "invoice-item invoice-item-selected",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "electro-invoice-content-1"
    },
    on: {
      "click": _vm.contentTab1
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t不开发票"), _c('b')]), _vm._v(" "), _c('li', {
    staticClass: "invoice-item",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "electro-invoice-content-2",
      "name": "electro-normalContent",
      "value": "1",
      "data-desc": "发票内容将显示详细商品名称与价格信息"
    },
    on: {
      "click": _vm.contentTab2
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t商品明细"), _c('b')])]), _vm._v(" "), _vm._m(13)])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "op-btns"
  }, [_c('a', {
    staticClass: "btn-1",
    on: {
      "click": function($event) {
        _vm.saveReceipt()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('a', {
    staticClass: "btn-9 ml10",
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_vm._v("取消")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-con",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "vat-inv"
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "form",
    attrs: {
      "id": "invoice-box-03"
    }
  }, [_c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("单位名称")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "invoice-list invoice-tit-list zy",
    attrs: {
      "id": "invoice-tit-list_lest1"
    }
  }, [_c('div', {
    staticClass: "invoice-item rise1 invoice-item-selected",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectTitle1($event, '-1', '')
      }
    }
  }, [_vm._m(15)]), _vm._v(" "), _vm._l((_vm.specialList), function(special) {
    return _c('div', {
      staticClass: "invoice-item rise1",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectTitle1($event, special.id, special.taxpayerNum, special.address, special.phone, special.openBank, special.openBankAccount)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "invoice-2"
      }
    }, [_c('input', {
      staticClass: "itxt",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "text",
        "id": "fff",
        "readonly": "true"
      },
      domProps: {
        "value": special.receiptTitle
      }
    }), _c('b')])])
  }), _vm._v(" "), _c('div', {
    staticClass: "invoice-item rise1",
    staticStyle: {
      "cursor": "pointer",
      "display": "none"
    },
    attrs: {
      "id": "newReceiptTitle1"
    },
    on: {
      "click": function($event) {
        _vm.selectTitle1($event, '0', '')
      }
    }
  }, [_vm._m(16)])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "item nor-inv-type0",
    attrs: {
      "id": "addEnterpriseRecipes1"
    },
    on: {
      "click": function($event) {
        _vm.addEnterprise1()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }), _vm._v(" "), _vm._m(17)]), _vm._v(" "), _c('div', {
    staticClass: "step vat-inv-type0 vat-inv-type1",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "vat-inv-type1"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "vatCanEdit",
      "value": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_code_div"
    }
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_code",
      "id": "vat_code",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_code', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_code', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_code_error"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_address_div"
    }
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_address",
      "id": "vat_address",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_address', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_address', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_address_error"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_phone_div"
    }
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_phone",
      "id": "vat_phone",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_phone', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_phone', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_phone_error"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_bankName_div"
    }
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_bankName",
      "id": "vat_bankName",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_bankName', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_bankName', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_bankName_error"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "id": "vat_bankAccount_div"
    }
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt04 vat-step-1",
    attrs: {
      "type": "text",
      "name": "vat_bankAccount",
      "id": "vat_bankAccount",
      "value": ""
    },
    on: {
      "blur": function($event) {
        _vm.check_Invoice('vat_bankAccount', $event)
      },
      "change": function($event) {
        _vm.check_Invoice('vat_bankAccount', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "message ",
    attrs: {
      "id": "vat_bankAccount_error"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "label"
  }), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "op-btns"
  }, [_c('a', {
    staticClass: "btn-1",
    attrs: {
      "id": "vat-btn-save",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveReceipt1()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('a', {
    staticClass: "btn-9 ml10",
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_vm._v("取消")])])])])])])])])]), _vm._v(" "), _c('a', {
    staticClass: "ui-dialog-close",
    attrs: {
      "title": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.closemodal()
      }
    }
  }, [_c('span', {
    staticClass: "ui-icon ui-icon-delete"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hq-reg-step"
  }, [_c('ul', {
    staticClass: "ico"
  }, [_c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("购物车")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('p', {
    staticClass: "item"
  }, [_vm._v("提交订单")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("确认付款")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "item"
  }, [_vm._v("下单成功")]), _vm._v(" "), _c('i', {
    staticClass: "step-count"
  })])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd-title clear-l"
  }, [_c('h4', {}, [_vm._v("确认收货地址")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bd-box fill-ordering mt20",
    attrs: {
      "id": "nearbyCompanyMap"
    }
  }, [_c('div', {
    staticClass: "hd-title-2"
  }, [_c('h4', {}, [_vm._v("附近商家")])]), _vm._v(" "), _c('div', {
    staticClass: "mapPage",
    attrs: {
      "id": "mapPage"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd-title-2"
  }, [_c('h4', {}, [_vm._v("确认订单信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', {
    staticClass: "col-1"
  }, [_c('span', {
    staticClass: "ml20"
  }, [_vm._v("商品名称")])]), _vm._v(" "), _c('dt', {
    staticClass: "col-2"
  }, [_vm._v("配送方式")]), _vm._v(" "), _c('dt', {
    staticClass: "col-3"
  }, [_vm._v("单价")]), _vm._v(" "), _c('dt', {
    staticClass: "col-4"
  }, [_vm._v("服务费")]), _vm._v(" "), _c('dt', {
    staticClass: "col-5"
  }, [_vm._v("数量")]), _vm._v(" "), _c('dt', {
    staticClass: "col-6"
  }, [_vm._v("总价")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dt', {
    staticClass: "col-1",
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_c('span', {
    staticClass: "ml20"
  }, [_vm._v("商品名称")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/footer-ad-1.png"),
      "width": "1200",
      "height": "60"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui-dialog-title"
  }, [_c('span', [_vm._v("发票信息")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice-tips ftx-03 mt10 mb10 ",
    attrs: {
      "id": "electro-invoice-tips"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "tip-cont"
  }, [_vm._v("电子普通发票和纸质普通发票具备同等法律效力，可支持报销入账，京东自营全面启用电子普通发票，")]), _vm._v(" "), _c('span', {
    staticClass: "tip-cont ml30"
  }, [_vm._v("非京东自营发票由第三方商家实际开具。"), _c('a', {
    staticClass: "ftx-05",
    attrs: {
      "target": "_blank",
      "href": "//help.jd.com/user/issue/list-505-508.html"
    }
  }, [_vm._v("电子普通发票相关信息>>")])]), _vm._v(" "), _c('span', {
    staticClass: "tip-cont ml30"
  }, [_vm._v("如商品由第三方卖家销售，发票类型及内容将由该卖家决定。"), _c('a', {
    staticClass: "ftx-05",
    attrs: {
      "target": "_blank",
      "href": "//help.jd.com/user/issue/list-505-508.html"
    }
  }, [_vm._v("发票信息相关问题>>")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "invoice-2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "4"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fore2"
  }, [_c('input', {
    staticClass: "itxt",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "text",
      "id": "fff",
      "value": "个人",
      "readonly": "true"
    }
  }), _c('b')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "invoice-2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "5"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "itxt itxt04",
    attrs: {
      "type": "text",
      "placeholder": "请填写公司发票抬头"
    }
  }), _c('b')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('a', {
    staticClass: "ftx-05"
  }, [_vm._v("新增企业发票")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item nor-inv-type0",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "ele_code_div"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("纳税人识别号")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('input', {
    staticClass: "itxt itxt05",
    attrs: {
      "type": "text",
      "placeholder": "纳税人识别号",
      "name": "ele_code",
      "id": "ele_code",
      "value": ""
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ftx03",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "receiptContent"
    }
  }, [_c('i', {
    staticClass: "warn-icon"
  }), _vm._v("发票内容将显示详细商品名称与价格信息\n\t\t\t\t\t\t\t\t\t\t")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoice-tips ftx-03 mt10 mb10 ",
    attrs: {
      "id": "vat-invoice-tips"
    }
  }, [_c('i'), _vm._v(" "), _c('span', {
    staticClass: "tip-cont"
  }, [_vm._v("我司依法开具发票，请您按照税法规定使用发票。")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "invoice-2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "4"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "fore2"
  }, [_c('input', {
    staticClass: "itxt",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "text",
      "id": "fff",
      "value": "不开发票",
      "readonly": "true"
    }
  }), _c('b')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "invoice-2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "value": "5"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "itxt itxt04",
    attrs: {
      "type": "text",
      "placeholder": "请填写单位名称"
    }
  }), _c('b')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('a', {
    staticClass: "ftx-05"
  }, [_vm._v("新增企业发票")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("纳税人识别码")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("注册地址")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("注册电话")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("开户银行")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('em', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("银行账户")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11c1f2f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/orderCommit.vue
// module id = jCf5
// module chunks = 1